// @flow

export const ClearSettings = "CLEAR_SETTINGS";

export const GetSettings = "GET_SETTINGS";
export const GetSettingsSuccess = "GET_SETTINGS_SUCCESS";
export const GetSettingsError = "GET_SETTINGS_ERROR";
